import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useLang } from "@/lib/i18n";

export const PasswordInput = ({ testid = "password-input", ...props }) => {
  const [show, setShow] = useState(false);
  const { t } = useLang();
  return (
    <div className="relative">
      <Input type={show ? "text" : "password"} className="h-12 pr-12 rounded-xl" data-testid={testid} {...props} />
      <button type="button" onClick={() => setShow(!show)} aria-label={show ? t("hide_pw") : t("show_pw")} data-testid={`${testid}-toggle`}
        className="absolute right-1 top-1 grid h-10 w-10 place-items-center rounded-lg text-slate-500 hover:text-[#142B5C]">
        {show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
      </button>
    </div>
  );
};

const STATUS = {
  draft: "bg-slate-100 text-slate-600 border-slate-300",
  review: "bg-amber-50 text-amber-700 border-amber-200",
  published: "bg-green-50 text-green-700 border-green-300",
  suspended: "bg-red-50 text-red-700 border-red-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  accepted: "bg-green-50 text-green-700 border-green-300",
  rejected: "bg-red-50 text-red-700 border-red-200",
  cancelled: "bg-slate-100 text-slate-600 border-slate-300",
};

export const StatusBadge = ({ status, testid }) => {
  const { t } = useLang();
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider ${STATUS[status] || STATUS.draft}`} data-testid={testid || `status-${status}`}>
      {t(`s_${status}`)}
    </span>
  );
};

export const Field = ({ label, children, hint }) => (
  <label className="grid gap-1.5">
    <span className="text-sm font-semibold text-[#142B5C]">{label}</span>
    {children}
    {hint && <span className="text-xs text-slate-500">{hint}</span>}
  </label>
);

export const Empty = ({ text, testid }) => (
  <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-10 text-center text-slate-500" data-testid={testid}>{text}</div>
);
